module.exports = __webpack_public_path__ + "img/people_elements_24.ea79c393.svg";